export default "__VITE_ASSET__a69d7d66__"